import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Notification } from 'src/app/models/notification/notification';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { environment } from 'src/environments/environment';
import {
  HttpService,
  LocalStorageService,
  MessageService,
  SessionService,
} from 'brainloper-ui';
import { SocketWebService } from './socket-web.service';
import { UtilsServiceService } from './utils-service.service';
import { GenericResponse } from 'src/app/models/commos/generic-response';
import { User } from 'src/app/models/administration/user';
import { WorkOrder } from 'src/app/models/maintenance/work-order';
import { Provider } from 'src/app/models/administration/provider';
import { Resources } from 'src/app/models/maintenance/resources';
import { BaseResponse } from 'src/app/models/commos/base-response';
import { Notifications } from '@edgarzon93/brainloper-shared';
import { INotificationByCompany } from 'src/app/models/maintenance/notification-by-company';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private urlPostNotification: string = `${EndpointDictionary.Notification.CRUD_NOTIFICATION_DATA}`;
  private urlDeleteNotificaciones: string = `${EndpointDictionary.Notification.CRUD_NOTIFICATION_DATA}`;
  private urlDelteNotificacionUrl: string = `${EndpointDictionary.Notification.NOTIFICATION_DELETE}`;
  private urlPutResourcesReady: string = `${EndpointDictionary.WorkOrder.WORK_ORDER_RESOURCES_READY}`;

  companyId: number | null = null;

  constructor(
    private message: MessageService,
    private http: HttpService,
    private storage: LocalStorageService,
    private router: Router,
    private socketWebService: SocketWebService,
    private session: SessionService,
    private utils: UtilsServiceService
  ) {
    this.companyId = this.storage.get('companyId');
  }

  public async sendNotification(
    url: string,
    descripcion: string,
    notificationTypeId: number,
    notificado?: string | number,
    comanyId?: number,
    rolId?: number
  ) {
    let bodyNotification: Notification = {
      description: descripcion,
      url: url,
      notified: notificado,
      roleId: rolId,
      notificationTypeId: notificationTypeId,
      companyId: comanyId,
    };

    let sendNotification = await this.http.postDataBody(
      `${this.urlPostNotification}`,
      bodyNotification
    );
    if (sendNotification) {
      this.emitUpdateNotificationsByNotification(bodyNotification);
      return true;
    }
  }

  public async getNotifications(): Promise<Array<Notification>> {
    var norifications: Array<Notification> = [];
    try {
      let res: Array<Notification> = await this.http.getDataBody(
        `${EndpointDictionary.Notification.NOTIFICATION_COMBO}`
      );
      if (res) {
        norifications = res;
        const maintenanceCount = norifications.filter(
          (notification) => notification.title === 'Mantenimiento'
        ).length;
        this.session.setData('maintenanceOrderCount', maintenanceCount);
        const fuelCount = norifications.filter(
          (notification) => notification.title === 'Orden combustible'
        ).length;
        this.session.setData('fuelOrderCount', fuelCount);
      }
    } catch (error) {
      this.message.Error('Error', error['message']);
    }

    return norifications;
  }

  public async handlerNotification(notification: Notification) {
    if (notification.url == '') {
      this.deleteNotificationById(notification);
    } else {
      this.router.navigate(['/inicio']);
      this.session.setData('id_notificacion', notification.id);
      setTimeout(() => {
        let url = this.utils.getQueryParams(notification.url);
        this.router.navigate([`${url.url}`], {
          queryParams: url.params,
        });
      }, 100);
    }
  }

  public async deleteNotificationByUrl(
    urlNotification: string
  ): Promise<boolean> {
    let res: GenericResponse = await this.http.postDataBody(
      `${this.urlDelteNotificacionUrl}`,
      { url: urlNotification }
    );
    if (res && res.notification.length > 0)
      this.emitUpdateNotificationsByNotifications(res.notification);
    return true;
  }

  public async deleteNotificationsByUrl(urlNotification: Array<string>) {
    for (let element of urlNotification) {
      this.deleteNotificationByUrl(element);
    }
  }

  public async deleteNotificationById(notification: Notification) {
    try {
      let resDeleteNotificacion: BaseResponse<Array<Notification>> =
        await this.http.deleteDataPromise(
          `${this.urlDeleteNotificaciones}/${notification.id}`
        );
      if (resDeleteNotificacion['code'] === 0) {
        if (this.companyId == null) {
          this.companyId = this.storage.get('companyId');
        }
        for (let n of resDeleteNotificacion.body) {
          let notificationData: INotificationByCompany = {
            userId: n.notified.toString(),
            companyId: this.companyId.toString(),
          };
          this.socketWebService.emit('update-notification', notificationData);
        }
      } else {
        this.message.Error('Error', resDeleteNotificacion['message']);
      }
    } catch (error) {
      this.message.Error('Error', error['message']);
    }
  }

  public async sendNotificationRequestQueue(
    description: string,
    requestId: number
  ): Promise<boolean> {
    return await this.sendNotification(
      `${Notifications.requestQueue.urlBase}${requestId}`,
      description,
      Notifications.requestQueue.notificationTypeId,
      this.storage.get<number>('userId'),
      this.storage.get<number>('companyId')
    );
  }

  public async sendNotificationAutorizeRequest(
    description: string,
    requestId: number
  ): Promise<boolean> {
    return await this.sendNotification(
      `${Notifications.autorizeRequest.urlBase}${requestId}`,
      description,
      Notifications.autorizeRequest.notificationTypeId,
      0,
      this.storage.get<number>('companyId'),
      environment.idRolMaintenanceManager
    );
  }

  public async sendNotificationMaintenance(
    description: string,
    requestId: number,
    notified: number | string
  ): Promise<boolean> {
    return await this.sendNotification(
      `${Notifications.maintenance.urlBase}${requestId}`,
      description,
      Notifications.maintenance.notificationTypeId,
      notified,
      this.storage.get<number>('companyId')
    );
  }

  public async sendNotificationsMaintenanceByUsers(
    workOrder: WorkOrder,
    users: User[]
  ) {
    for (let element of users) {
      if (element.userId) {
        let descripcion = `Equipo:${workOrder.code} / ${workOrder.description} `;
        let notificado = element.userId;
        await this.sendNotificationMaintenance(
          descripcion,
          workOrder.id,
          notificado
        );
      }
    }
  }

  public async sendNotificationAutorizeMaintenance(
    description: string,
    requestId: number,
    notified: number
  ): Promise<boolean> {
    return await this.sendNotification(
      `${Notifications.autorizeMaintenance.urlBase}${requestId}`,
      description,
      Notifications.autorizeMaintenance.notificationTypeId,
      notified,
      this.storage.get<number>('companyId')
    );
  }

  public async sendNotificationFuelRequestQueue(
    description: string,
    requestId: number
  ): Promise<boolean> {
    return await this.sendNotification(
      `${Notifications.fuelRequestQueue.urlBase}${requestId}`,
      description,
      Notifications.fuelRequestQueue.notificationTypeId,
      this.storage.get<number>('userId'),
      this.storage.get<number>('companyId')
    );
  }

  public async sendNotificationAutorizeFuelRequest(
    description: string,
    requestId: number
  ): Promise<boolean> {
    return await this.sendNotification(
      `${Notifications.autorizeFuelRequest.urlBase}${requestId}`,
      description,
      Notifications.autorizeFuelRequest.notificationTypeId,
      0,
      this.storage.get<number>('companyId'),
      environment.idRolMaintenanceManager
    );
  }

  public async sendNotificationFuelOrder(
    description: string,
    requestId: number,
    notificado: string
  ): Promise<boolean> {
    return await this.sendNotification(
      `${Notifications.fuelOrder.urlBase}${requestId}`,
      description,
      Notifications.fuelOrder.notificationTypeId,
      notificado,
      this.storage.get<number>('companyId')
    );
  }

  public async sendNotificationInformative(
    description: string,
    notificado: number
  ): Promise<boolean> {
    return await this.sendNotification(
      Notifications.informative.urlBase,
      description,
      Notifications.informative.notificationTypeId,
      notificado,
      this.storage.get<number>('companyId')
    );
  }

  public async sendNotificationStorer(
    description: string,
    requestId: number
  ): Promise<boolean> {
    return await this.sendNotification(
      `${Notifications.storer.urlBase}${requestId}`,
      description,
      Notifications.storer.notificationTypeId,
      Notifications.storer.notificado,
      this.storage.get<number>('companyId'),
      Notifications.storer.idRol
    );
  }

  async sendOrderRadyNotification(
    bodyOrder: WorkOrder,
    bodyUsers: User[] | Provider[],
    resources: Resources[],
    notificationId: number
  ) {
    await this.http.putDataBody(
      `${this.urlPutResourcesReady}/${bodyOrder.id}`,
      { resourcesInventory: resources }
    );
    await this.sendNotificationMaintenance(
      `Equipo: ${bodyOrder.code} / ${bodyOrder.description}`,
      bodyOrder.id,
      bodyOrder.responsibleId
    );
    if (!bodyUsers[0]['providerId']) {
      await this.sendNotificationsMaintenanceByUsers(bodyOrder, bodyUsers);
    }
    this.deleteNotificationByUrl(
      `notificaciones/despacho?id_orden_trabajo=${bodyOrder.id}`
    );
  }

  public emitUpdateNotificationsByNotification(notification: Notification) {
    this.socketWebService.updateNotificationEmit(notification);
  }

  public emitUpdateNotificationsByNotifications(
    notifications: Array<Notification>
  ) {
    this.socketWebService.updateNotificationsEmit(notifications);
  }
}
